import { Button } from "antd";
import { useState } from "react";
import FullscreenIcon from "../../../assets/icons/fullscreen.svg";
import ShareIcon from "../../../assets/icons/share.svg";
import ShareModalComponent from "../../../components/ShareModalComponent";
import { ILive } from "../../../helpers/types";
import { APP_DOMAIN } from "../../../utls/constants";
import "./index.less";

interface Props {
  id: string;
  live: ILive | null;
}

export const FanLiveRTMPFooter = (props: Props) => {
  const { id, live } = props;
  const [isShareModalOpen, setIsShareModalOpen] = useState<boolean>(false);

  const handleFullscreen = () => {
    // Get the video element - we don't need an index, just find the first video in the RTMP player
    const videoElement = document.querySelector(".rtmp-jvs video") as HTMLVideoElement;

    if (videoElement) {
      if (!document.fullscreenElement) {
        if (videoElement.requestFullscreen) {
          videoElement.requestFullscreen();
        } else if ((videoElement as any).webkitEnterFullscreen) {
          (videoElement as any).webkitEnterFullscreen();
        }

        // Try to force landscape orientation
        if (window.screen.orientation) {
          try {
            // Use the correct type for orientation lock
            if ("lock" in window.screen.orientation) {
              (window.screen.orientation as any).lock("landscape");
            }
          } catch (error) {
            console.error("Failed to lock orientation:", error);
          }
        }
      } else {
        // Exit fullscreen
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if ((document as any).webkitExitFullscreen) {
          (document as any).webkitExitFullscreen();
        }
      }
    }
  };

  return (
    <>
      <div className="z-fan-live mb-5">
        <div className="fs-style-controls-container">
          <div className="fs-style-controls">
            <Button
              className="fullscreen-button"
              onClick={handleFullscreen}
              icon={<img src={FullscreenIcon} width={20} height={20} alt="fullscreen" />}
            />
            <Button
              className="fullscreen-button"
              onClick={() => setIsShareModalOpen(true)}
              icon={<img src={ShareIcon} width={20} height={20} alt="share" />}
            />
          </div>
        </div>
      </div>
      <ShareModalComponent
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        id={live?.creator?._id}
        username={live?.creator?.username}
        link={`https://${APP_DOMAIN}/ifc3`}
        headerTitle="share-stream-via"
      />
    </>
  );
};
